module.exports = __webpack_public_path__ + "img/img29.1194fbb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index/img29.png
// module id = 373
// module chunks = 0